export const CREATE_REMINDER_INIT = 'CREATE_REMINDER_INIT';
export const CREATE_REMINDER_SUCCESS = 'CREATE_REMINDER_SUCCESS';
export const CREATE_REMINDER_ERROR = 'CREATE_REMINDER_ERROR';
export const CREATE_REMINDER_CLEAR = 'CREATE_REMINDER_CLEAR';

export const LIST_REMINDER_INIT = 'LIST_REMINDER_INIT';
export const LIST_REMINDER_SUCCESS = 'LIST_REMINDER_SUCCESS';
export const LIST_REMINDER_ERROR = 'LIST_REMINDER_ERROR';

export const DELETE_REMINDER_INIT = 'DELETE_REMINDER_INIT';
export const DELETE_REMINDER_SUCCESS = 'DELETE_REMINDER_SUCCESS';
export const DELETE_REMINDER_ERROR = 'DELETE_REMINDER_ERROR';
export const DELETE_REMINDER_CLEAR = 'DELETE_REMINDER_CLEAR';
